import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import clsx from 'clsx';
import { AnalyticsWrapper } from 'src/features/travel/TravelNerdBanner/Analytics/AnalyticsWrapper';
import { SignUpForm } from 'src/features/travel/TravelNerdBanner/SignUpForm';
export function FormWithLegals(t0) {
  const $ = _c(12);
  const {
    includesSweepstakes: t1
  } = t0;
  const includesSweepstakes = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      impressionPosition: 0
    };
    t3 = clsx("flex", "flex-col", "sm:max-w-[636px]");
    t4 = <h1 className={clsx("text-[30px]", "lg:text-[40px]", "font-bold", "text-black", "m-0", "mb-4", "sm:mb-6")}>Like getting the "cheat codes" to unlocking cheaper travel (100% legal)</h1>;
    t5 = <p className={clsx("text-base", "text-black", "m-0", "mb-6")}>Subscribe to NerdWallet's brand-new travel newsletter for inspiration, tips, deals and money-saving strategies – delivered straight to your inbox</p>;
    t6 = <div className={clsx("mb-4")}><SignUpForm isTravelNewsLetter={true} /></div>;
    t7 = clsx("text-[12px]", "m-0", "text-neutral-darker-2");
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <a href={`${env.NEXT_PUBLIC_NW_URL}p/terms-of-use`} target="_blank" rel="noopener noreferrer" className={clsx("text-neutral-darker-2", "no-underline", "hover:underline")}>Terms of Use</a>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <a href={`${env.NEXT_PUBLIC_NW_URL}p/privacy-policy`} target="_blank" rel="noopener noreferrer" className={clsx("text-neutral-darker-2", "no-underline", "hover:underline")}>Privacy Policy</a>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== includesSweepstakes) {
    t10 = includesSweepstakes && <span>{" "}Official sweepstakes rules can be found{" "}<a href={`${env.NEXT_PUBLIC_NW_URL}article/travel/travelnerd-official-sweepstakes-rules`} target="_blank" rel="noopener noreferrer" className={clsx("text-green-default", "no-underline", "hover:underline")}>here</a>.</span>;
    $[8] = includesSweepstakes;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10) {
    t11 = <AnalyticsWrapper analytics={t2}><section className={t3}>{t4}{t5}{t6}<p className={t7}>By signing up, you will receive newsletters and promotional content and agree to our{" "}{t8}{" "}and acknowledge the data practices in our{" "}{t9}. You may unsubscribe at any time.{t10}</p></section></AnalyticsWrapper>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}